import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contacto" className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <svg width="200" height="40" viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <text x="0" y="28" fontSize="24" fontWeight="700" fontFamily="Inter, sans-serif">
                  <tspan fill="#B91C1C">Multi</tspan>
                  <tspan fill="#e8641e">servicios</tspan>
                </text>
                <line x1="0" y1="35" x2="167" y2="35" stroke="#e8641e" strokeWidth="3"/>
              </svg>
            </div>
            <p className="footer-description">
              Tu plan multiservicios de confianza. Ofrecemos asistencia integral 
              para que puedas vivir con tranquilidad las 24 horas del día.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Servicios</h3>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('servicios')} className="footer-link">Asistencia al Hogar</button></li>
              <li><button onClick={() => scrollToSection('servicios')} className="footer-link">Asistencia Mascotas</button></li>
              <li><button onClick={() => scrollToSection('servicios')} className="footer-link">Asistencia Salud</button></li>
              <li><button onClick={() => scrollToSection('servicios')} className="footer-link">Asistencia Movilidad</button></li>
              <li><button onClick={() => scrollToSection('servicios')} className="footer-link">Asistencia Tecnológica</button></li>
              <li><button onClick={() => scrollToSection('servicios')} className="footer-link">Asistencia Legal</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Empresa</h3>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('nosotros')} className="footer-link">Sobre Nosotros</button></li>
              <li><button onClick={() => scrollToSection('faq')} className="footer-link">Preguntas Frecuentes</button></li>
              <li><button onClick={() => scrollToSection('terminos')} className="footer-link">Términos y Condiciones</button></li>
              <li><a href="#" className="footer-link">Política de Privacidad</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Multiservicios. Todos los derechos reservados.</p>
            <div className="footer-bottom-links">
              <a href="#" className="footer-bottom-link">Política de Cookies</a>
              <a href="#" className="footer-bottom-link">Aviso Legal</a>
              <a href="#" className="footer-bottom-link">Mapa del Sitio</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;